<template lang="html">
  <div class="medios">
    <section class="middle-intro row-start">
      <div class="container">
        <h1 class="title -intro">{{ $t("menu.medios") }}</h1>
         <img
          src="/static/img/gifs/medios.gif"
          class="imagen-animacion" alt="imagen animacion"
        />
      </div>
    </section>
    <div class="container">
      <section class="tool-search">
        <input
          type="text"
          :placeholder="$t('blog.buscar')"
          id="searchTool"
          v-model="textSearch"
          @keyup.enter="search"
        />
        <button @click="search" class="btn-search fa fa-search"></button>
      </section>
    </div>

    <section class="list-entries container">
      <div class="all-entries">
        <div class="blog-el" v-for="(medio, key) in medio" :key="key">
          <!-- :class="[key == 0 ? 'full-view' : '']" -->
          <div class="box-blog">
            <div
              class="img"
              :style="`background-image:url(` + medio.image.url + `)`"
            ></div>
            <div class="content">
              <p class="title">{{ medio.title }}</p>
              <!-- <p class="date">{{ currentDateTime(medio.updated_at) }}</p> -->
              <template v-for="(el, key) in data">
                <div :key="key" v class="parrafo">
                  {{ el }}
                  <p v-html="el.texto"></p>
                </div>
              </template>
              <div class="description">
                {{ medio.description }}
              </div>
              <p class="date">{{ medio.media }}</p>
              <a target="_blank"
                :href="medio.url"
                class="link-btn"
              ></a>
            </div>
          </div>
        </div>
      </div>
      <button
        class="btn-rounded-blue"
        @click="moreEntries"
        v-if="total != medio.length"
        tabindex="-1"
      >
        {{ $t("blog.cargarMas") }}
      </button>
    </section>
  </div>
</template>

<script lang="js">
import router from '@/router';
import moment from 'moment'

import { mapGetters, mapActions } from "vuex";
export default  {
  name: 'medios',
  props: [],
  mounted() {
    this.setData();
  },
  data() {
    return {
      medio : [],
      textSearch: "",
      data:[],
      total: null,
      actualPage: 1,
    }
  },
  methods: {
     currentDateTime() {
      return moment().locale('es').format('LL')
    },
    ...mapActions(["requestMedios"]),
    setData() {
      let data = {
        // length: (this.actualPage == 1 ) ? 6: 6,
        length: 6,
        page: this.actualPage,
        filters: [
          {
            name: "title",
            search: this.textSearch,
            textFilter: 1,
          },
        ],
      };

      this.loading = true;

      this.requestMedios(data).then((r) => {
        this.medio = this.medio.concat(r.data);
        this.loading = false;
        this.total = r.recordsFiltered;
      });
    },
      moreEntries() {
        this.actualPage++;
        this.setData();
    },

    search(){
      this.actualPage = 1;
      this.medio = [];
      this.setData();
    }
  },
   computed: {
    ...mapGetters({
      server: "getServer",
    }),
    pages() {
      return Math.ceil(this.total / this.perpage);
    },
  },
  components: {
  },
  watch: {
    "$route.params.id"() {
      this.setData();
    },
    'textSearch'(){
      if(this.textSearch == ""){
        this.actualPage = 1;
        this.medio = [];
        this.setData();
      }
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/views/medios.vue